let uid = 0

export default {
    name: "SchemaMarkupDropdown",

    props: {
        modelValue: { type: [String, Number], default: "" },
        label: { type: String, default: "" },
        options: { type: Array, default: () => [] },
        disabled: { type: Boolean, default: false }
    },

    emits: ["update:modelValue"],

    setup(props, { emit }) {
        const fieldId = `kb-dropdown-${++uid}`
        const onChange = (event) => emit("update:modelValue", event.target.value)
        return { fieldId, onChange }
    }
}
